import { Client } from 'colyseus.js';

// Endpoint resolution:
//  - explicit VITE_COLYSEUS_URL wins (any environment)
//  - Vite dev server (port 5173) talks directly to the game server on :2567
//  - otherwise (production behind nginx) use the same origin, upgrading to wss
//    under https — the server serves the client and proxies the WebSocket.
const endpoint =
  (import.meta.env.VITE_COLYSEUS_URL as string | undefined) ||
  (location.port === '5173'
    ? `ws://${location.hostname}:2567`
    : `${location.protocol === 'https:' ? 'wss' : 'ws'}://${location.host}`);

export const colyseusClient = new Client(endpoint);
